var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27247",
    "data-name": "Group 27247",
    transform: "translate(952 -513.39)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_brifecase-timer",
    "data-name": "vuesax bold brifecase-timer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    d: "M-930.91,520.37c-.85-.94-2.26-1.41-4.33-1.41h-.24v-.04c0-1.68,0-3.76-3.76-3.76h-1.52c-3.76,0-3.76,2.08-3.76,3.76v.04h-.24c-2.07,0-3.49.47-4.33,1.41a4.555,4.555,0,0,0-.86,3.59l.01.07.09,1.05c.34.22.72.47,1.08.67.14.09.29.17.44.25a16.631,16.631,0,0,0,3.58,1.45,4.751,4.751,0,0,0,4.78,4.72,4.75,4.75,0,0,0,4.72-4.78v-.04a16.7,16.7,0,0,0,3.6-1.57c.06-.03.1-.06.15-.09a13.883,13.883,0,0,0,1.36-.89l.04-.36.05-.47c.01-.06.01-.11.02-.18A4.417,4.417,0,0,0-930.91,520.37Zm-12.18-1.45c0-1.7,0-2.34,2.33-2.34h1.52c2.33,0,2.33.64,2.33,2.34v.04h-6.18ZM-940,530.64a3.252,3.252,0,0,1-3.22-2.84,2.815,2.815,0,0,1-.03-.41,3.25,3.25,0,0,1,3.25-3.25,3.25,3.25,0,0,1,3.25,3.25c0,.12-.01.23-.02.34v.01A3.258,3.258,0,0,1-940,530.64Z",
    fill: "#fafcfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    d: "M-930.35,526.76l-.42,4.59c-.21,2-1.03,4.04-5.43,4.04h-7.62c-4.4,0-5.22-2.04-5.42-4.03l-.41-4.39s.43.25.6.34a17.057,17.057,0,0,0,2.42,1.11,1,1,0,0,1,.62.69,6.288,6.288,0,0,0,6.01,4.53,6.251,6.251,0,0,0,6.04-4.67,1,1,0,0,1,.61-.7,18.234,18.234,0,0,0,2.39-1.15C-930.87,527.07-930.38,526.78-930.35,526.76Z",
    fill: "#fafcfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    d: "M-928,537.39h-24v-24h24Z",
    fill: "#fafcfe",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_setting",
    "data-name": "vuesax bold setting"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M-938.71,526.231l-.961-.556a.716.716,0,0,0-.656,0l-.97.56c-.384.26-.407.3-.407.713v1.009c0,.415.023.456.415.719l.96.556a.676.676,0,0,0,.329.081.665.665,0,0,0,.327-.08l.97-.56c.385-.26.407-.3.407-.713v-1.012C-938.3,526.534-938.318,526.495-938.71,526.231Zm-1.29,1.827a.6.6,0,0,1-.6-.6.6.6,0,0,1,.6-.6.6.6,0,0,1,.6.6h0a.606.606,0,0,1-.6.6Z",
    fill: "#fafcfe"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.1424606531f5ac94ff08715a8ed3b345.svg";
export { ForwardRef as ReactComponent };